module.exports = __webpack_public_path__ + "6f9ccb22d63d71df9823ade1c5e4bedb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/write-illustration.svg
// module id = 2548
// module chunks = 0